import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';

import BotSettingApi from 'api/bot-setting';

import DataForm from 'components/ui/DataForm';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import UserAvatarForm from 'components/users/UserAvatarForm';
import BotAboutForm from 'components/bots/BotAboutForm';
import BotNotificationForm from 'components/bots/BotNotificationForm';

const ConfigPage = ({ bot }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutationParams = {
    onSuccess: () => {
      queryClient.invalidateQueries(`bot-${bot.id}-config`);
    },
  };

  const setting_key = 'config';
  const updateConfigMutation = useMutation(data => BotSettingApi.update(bot.id, setting_key, data), mutationParams);

  const config = (bot.settings || []).find(setting => setting.id === setting_key) || {};
  const bot_schema = (bot.schemas || []).find(schema => schema.id === setting_key) || {};
  const schema = bot_schema.schema || { description: t('bots.config.task.no_form_message'), type: 'object', properties: [] };
  const uiSchema = bot_schema.ui_schema || {};

  const settings = {
    schema,
    uiSchema,
    formData: config.value,
  };

  const onSubmit = async e => {
    const formData = e.formData || {};
    const config_value = config.value || {};
    const value = { ...config_value, ...formData };
    await updateConfigMutation.mutate({ value });
  };

  const NoFormMessage = schema.properties ? null : <div>{t('bots.config.task.no_form_message')}</div>;

  return (
    <div className="container">
      <div className="row mt-4">
        {!bot.is_customized ? null : (
          <div className="col-md-3 mb-3">
            <UserAvatarForm user={bot} edit_mode_on type="bot" />
          </div>
        )}

        <div className="col-md-4 mb-3">
          <BotAboutForm bot={bot} />
        </div>

        <div className="card col-md-4">
          <div className="card-body">
            <h6 className="mb-3 col-md-8 text-muted text-uppercase">{schema.title || t('bots.config.task.title')}</h6>
            <hr />

            {NoFormMessage}

            <DataForm {...settings} onSubmit={onSubmit} disabled={updateConfigMutation.isLoading}>
              <hr />
              <div className="text-right">
                <SubmitButton className="btn btn-primary" disabled={!schema.properties} loading={updateConfigMutation.isLoading} />
              </div>
            </DataForm>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <BotNotificationForm bot={bot} />
        </div>
      </div>
    </div>
  );
};

export default ConfigPage;
